import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App.jsx";
import "react-toastify/dist/ReactToastify.css";
import store from "./store/index.js";
import { Provider } from "react-redux";
import ConfigContextProvider from "./contexts/ConfigContextProvider.jsx";
import { HashRouter } from "react-router-dom";
import "../node_modules/bootstrap/dist/css/bootstrap.min.css";
import "../node_modules/bootstrap/dist/js/bootstrap.bundle.js";

createRoot(document.getElementById("root")).render(
  <>
    <HashRouter>
      <ConfigContextProvider>
        <Provider store={store}>
          <App />
        </Provider>
      </ConfigContextProvider>
    </HashRouter>
  </>
);
